import { Box, Container, Typography } from "@mui/material";
import { getProductListStaticProps } from "@cm-websites/common/dist/cms-api";
import { NavigationAndFooterLayout } from "../../layouts";
import { NextPageWithLayout, ProductGrid } from "@cm-websites/common";
import { NextSeo } from "next-seo";
import i18nConfig from "../../../next-i18next.config";
import React from "react";
import type { Product } from "@cm-websites/common";

type AlleSpieleProps = { products: Product[] };

export const PhysicalGamesPage: NextPageWithLayout<AlleSpieleProps> = ({ products = [] }) => (
  <React.Fragment>
    <NextSeo
      description="Übersicht über alle unsere Krimidinner-Fälle für Zuhause. Wähle zwischen 8 spannenden Fällen voller Intrigen, Spannung & Spaß."
      title="Das Krimi-Dinner für Zuhause"
    />
    <Box sx={{ pb: { xs: 8, sm: 10, lg: 14, xl: 16 } }}>
      <Container
        maxWidth="xl"
        sx={{ pt: { xs: 12, sm: 14, lg: 16 }, pb: { xs: 6, sm: 8, lg: 10, xl: 12 } }}
      >
        <Typography variant="h1" sx={{ hyphens: "none" }}>
          Das Krimi-Dinner für Zuhause
        </Typography>
      </Container>
      <ProductGrid products={products} />
    </Box>
  </React.Fragment>
);

PhysicalGamesPage.getLayout = (page) => <NavigationAndFooterLayout>{page}</NavigationAndFooterLayout>;

export default PhysicalGamesPage;

export const getStaticProps = getProductListStaticProps({
  edition: "print",
  fields: [
    "*.*",
    "relatedCases.related_Culinario_Mortale_id.*.*",
    "printVersionImages.*",
    "printVersionImages.directus_files_id.mask",
    "printVersionImages.directus_files_id.id",
    "printVersionImages.directus_files_id.description",
    "onlineVersionImages.*",
    "onlineVersionImages.directus_files_id.mask",
    "onlineVersionImages.directus_files_id.id",
    "onlineVersionImages.directus_files_id.description",
  ],
  filter: { language: "DE", status: "published" },
  i18nConfig,
  origin: "PRINT LIST",
});
